import {capitalize} from "../Helpers";
import {format} from "date-fns";
import {nb} from "date-fns/locale";

export const formatDate = (date: Date) => {
    return capitalize(
        format(date, "EEEE d'.' MMMM',' 'kl.' HH:mm", { locale: nb })
    )
}

export const displayPrice = (price: number | "") => {
    return `${price.toLocaleString("nb")},-`
}